import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import ContextStates from '../context/ContextStates'
import { FaMagnifyingGlass } from "react-icons/fa6";
import { Url } from './Url';

const SearchAutoComplete = (props) => {
    const [pos, setPos] = useState(0)
    const [searchTerm, setSearchTerm] = useState('');
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const { codigo, setCodigo, busqueda, setBusqueda } = useContext(ContextStates)
    const navigate = useNavigate();

    useEffect(() => {
        if (codigo === '') {
            setSearchTerm('')
            setPos(0)
            setBusqueda([])
            setIsDropdownVisible(false)
        }
    }, [codigo])

    const filter = (item) => {
        let bus = item.target.value
        setSearchTerm(item.target.value)
        if (props.items) {
            if (item.target.value !== '') {
                let rData = []
                props.items.forEach(element => {
                    const palabrasCadena = element.label.toLowerCase().split(/\s+/);
                    const palabras = bus.toLowerCase().split(/\s+/);
                    if (palabras.every(palabraBuscada => {
                        const encontrado = palabrasCadena.some(palabraCadena => {
                            if (palabraCadena.includes(palabraBuscada)) {
                                return true;
                            }
                            return false;
                        });
                        return encontrado;
                    })) {
                        rData.push(element)
                    }
                });
                setBusqueda(rData)
            }
            else {
                setBusqueda([])
            }
        }
    }

    const handleItemSelect = (item) => {
        setSearchTerm(item.label);
        setCodigo(item.codigo)
        setIsDropdownVisible(false);
        let rData = [];
        rData.push(item)
        setBusqueda(rData)
        if (props.mode === 1 && busqueda.length > 0 && searchTerm !== '') {
            navigate("/search", { replace: true });
        }
    };

    const handleKeyDown = (event) => {
        //console.log("cantidad ",props.items.length)
        let posAct = pos;
        setIsDropdownVisible(true);
        if (event.key === 'ArrowDown') {
            if (posAct < busqueda.length - 1) {
                posAct++;
                setPos(posAct)
                setHighlightedIndex(posAct)
            }
        } else if (event.key === 'ArrowUp') {
            if (posAct > 0) {
                posAct--;
                setPos(posAct)
                setHighlightedIndex(posAct)
            }
        } else if (event.key === 'Enter') {
            if (highlightedIndex >= 0 && highlightedIndex < busqueda.length) {

                handleItemSelect(busqueda[highlightedIndex]);
                if (props.mode === 1 && busqueda.length > 0 && searchTerm !== '') {
                    navigate("/search", { replace: true });
                }
            }
        }
    }

    return (
        <div className="w-full">
            {props.mode === 0 && (
                <label htmlFor="descripcion" className="block text-gray-600 uppercase font-bold">Descripción</label>
            )}
            <div className={`py-2 px-3 w-full flex bg-white border border-blue-300 ${props.mode === 0 ? 'rounded' : 'rounded-full'} `}>
                <input
                    type='text'
                    className={`w-full outline-none`}
                    value={searchTerm}
                    onChange={filter}
                    onKeyDown={handleKeyDown}
                />
                {props.mode === 1 && (

                    <FaMagnifyingGlass className='mt-1 ml-3 text-2xl text-gray-400' />
                )}
            </div>
            {isDropdownVisible && busqueda.length > 0 && (
                <ul
                    className='absolute mt-0 border border-gray-200 rounded-b-xl shadow-xl px-2 bg-white z-10'
                >
                    {busqueda.map((item, index) => (
                        <li
                            key={index}
                            onClick={() => handleItemSelect(item)}
                            className={`p-2 flex cursor-pointer ${highlightedIndex === index ? 'bg-blue-200' : 'bg-white'}`}
                        >
                            <img className="object-cover h-7 rounded mr-1" src={Url + item.imagenes[0].imagen} />
                            {item.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default SearchAutoComplete